import { Asset } from "@iventis/types/asset";

export abstract class BasemapDataStore<TBasemap> {
    protected readonly getBasemapAsset: (basemapId: string) => Promise<Asset>;

    private basemapIdToBasemap: Record<string, TBasemap> = {};

    private basemapRequestQueue: Record<string, Promise<TBasemap>> = {};

    constructor(getBasemapAsset: (assetIds: string[]) => Promise<Asset[]>) {
        this.getBasemapAsset = this.getSingleAsset(getBasemapAsset);
    }

    private getSingleAsset(getMultipleAssets: (assetIds: string[]) => Promise<Asset[]>) {
        return async (assetId: string) => {
            const res = await getMultipleAssets([assetId]);
            return res[0];
        };
    }

    private makeRequest(basemapId: string): Promise<TBasemap> {
        const existingRequest = this.basemapRequestQueue[basemapId];
        if (existingRequest) {
            return existingRequest;
        }

        this.basemapRequestQueue[basemapId] = this.getBasemapApiCall(basemapId);
        return this.basemapRequestQueue[basemapId];
    }

    protected abstract getBasemapApiCall(basemapId: string): Promise<TBasemap>;

    public async getBasemap(basemapId: string): Promise<TBasemap> {
        // Check if we have the list items locally
        const basemap = this.basemapIdToBasemap[basemapId];
        if (basemap) {
            return basemap;
        }

        this.basemapIdToBasemap[basemapId] = await this.makeRequest(basemapId);
        delete this.basemapRequestQueue[basemapId];
        return this.basemapIdToBasemap[basemapId];
    }

    public bustBasemapById(basemapId: string) {
        delete this.basemapIdToBasemap[basemapId];
    }
}
